export default __webpack_public_path__ + "static/media/contact-bg.70a0240d.jpg";